import type { PublicPlan } from "@/lib/checkout.functions";

function formatPrice(cents: number, currency: string) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency.toUpperCase(),
    maximumFractionDigits: 0,
  }).format(cents / 100);
}

interface Props {
  plan: PublicPlan;
  email?: string;
  website?: string;
}

export function OrderSummary({ plan, email, website }: Props) {
  return (
    <aside className="rounded-2xl border border-border bg-card/40 p-6">
      <p className="text-[10px] font-medium uppercase tracking-[0.18em] text-muted-foreground">
        Order summary
      </p>
      <div className="mt-4 flex items-baseline justify-between gap-3">
        <div>
          <h3 className="font-display text-lg font-semibold text-foreground">
            ShugertGEO, {plan.name}
          </h3>
          <p className="text-xs text-muted-foreground">
            {plan.delivery_label || `Delivered in ~${plan.eta_days} business days`}
          </p>
        </div>
        <p className="font-display text-xl font-semibold text-foreground">
          {formatPrice(plan.price_cents, plan.currency)}
        </p>
      </div>
      {(email || website) && (
        <dl className="mt-5 grid gap-2 border-t border-border pt-4 text-xs">
          {website && (
            <div className="flex justify-between gap-3">
              <dt className="text-muted-foreground">Website</dt>
              <dd className="truncate text-foreground">{website}</dd>
            </div>
          )}
          {email && (
            <div className="flex justify-between gap-3">
              <dt className="text-muted-foreground">Email</dt>
              <dd className="truncate text-foreground">{email}</dd>
            </div>
          )}
        </dl>
      )}
      <div className="mt-5 flex items-baseline justify-between border-t border-border pt-4">
        <span className="text-sm font-medium text-foreground">Total</span>
        <span className="font-display text-2xl font-semibold" style={{ color: "#C8A84B" }}>
          {formatPrice(plan.price_cents, plan.currency)}
        </span>
      </div>
    </aside>
  );
}